exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reTitle {\n  padding: 0.3rem 0;\n  display: flex;\n  align-items: center;\n  font-size: 0.16rem;\n}\n.reTitle .locaOfWarp {\n  display: flex;\n  align-items: center;\n  font-size: 0.16rem;\n  color: #666;\n}\n.reTitle .locaOfWarp i {\n  font-size: 0.18rem;\n}\n.reTitle .locaOfWarp .locaOf {\n  padding-left: 0.1rem;\n}\n.reTitle .el-breadcrumb {\n  font-size: 0.16rem;\n}\n.reTitle .el-breadcrumb span:last-child .el-breadcrumb__inner {\n  color: var(--mcol);\n}", ""]);

// exports
